if (!customElements.get("event-sale-pre-swiper-product")) {
  class PrizeCard extends HTMLElement {
    constructor() {
      super();
      this.swiperContainer = this.querySelector(".event-sale-pre-swiper-outer");
      this.swiperEl = this.swiperContainer.querySelector(".swiper");
      this.paginationEl =
        this.swiperContainer.querySelector(".swiper-pagination");
      this.nextBtn = this.swiperContainer.querySelector(".swiper-button-next");
      this.prevBtn = this.swiperContainer.querySelector(".swiper-button-prev");

      this.giftContainer = this.querySelector(
        ".event-sale-pre-swiper_gift-outer",
      );
      this.giftEl = this.giftContainer.querySelector(".swiper");
    }

    connectedCallback() {
      this.initGiftSwiper();
      this.initSwiper();
    }

    initGiftSwiper() {
      this.giftSwiper = new Swiper(this.giftEl, {
        slidesPerView: "auto",
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: false,
        watchSlidesProgress: true,
      });
    }

    initSwiper() {
      this.swiper = new Swiper(this.swiperEl, {
        slidesPerView: "auto",
        pagination: {
          el: this.paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },
        controller: {
          control: this.giftSwiper,
        },
      });
    }
    disconnectedCallback() { }
  }

  customElements.define("event-sale-pre-swiper-product", PrizeCard);
}

$(function () {
  var lastIsMobile = null;
  var $categoryWrapper = $(".event-sale-pre-swiper-product .category-wrapper");
  var $springSaleSection = $(".event-sale-pre-swiper-product");
  var $helpmeChooseSection = $(".spring-sale-pre-part3");
  var $springSalePopularProductSection = $(".event-sale-pre-swiper-product");
  var $salesNav = $(".spring-sale-pre-nav");
  var categoryWrapperTop = 0; // 记录“原始位置”的 top
  var springSaleSectionBottom = 0;
  var headerHeight = 0;

  function updateHeaderHeight() {
    var $header = $("header, .header, .site-header").first();
    headerHeight = $header.length ? $header.outerHeight() : 0;
  }

  // 更新分类栏原始位置（仅在非吸顶的时候调用）
  function updateCategoryWrapperTop() {
    if ($categoryWrapper.hasClass("sticky")) return; // sticky 时 offset 已失真，不要更新
    categoryWrapperTop = $categoryWrapper?.offset()?.top || 0;
  }

  // 更新容器底部位置的函数
  function updateSectionBottom() {
    springSaleSectionBottom =
      $springSaleSection.offset().top +
      $springSaleSection.outerHeight() +
      $helpmeChooseSection.outerHeight() +
      $springSalePopularProductSection.outerHeight();
  }

  // 初始化分类
  function initCategory() {
    var $categories = $(
      ".event-sale-pre-swiper-product .category-wrapper .category",
    );
    var $container = $(".event-sale-pre-swiper-product");
    var $boxes = $container.find(".product-box");

    updateHeaderHeight();
    updateCategoryWrapperTop();
    updateSectionBottom();
  }

  // 滚动监听函数
  function handleScroll() {
    var scrollTop = $(window).scrollTop();

    var isMobile = $(window).width() < 768;

    if (isMobile) {
      var wrapperHeight = $categoryWrapper.outerHeight() || 0;
      var stickStart = categoryWrapperTop - headerHeight;
      var stickEnd =
        springSaleSectionBottom - wrapperHeight - headerHeight - 120;

      if (scrollTop >= stickStart && scrollTop <= stickEnd) {
        // if (!$categoryWrapper.hasClass('sticky')) $categoryWrapper.addClass('sticky').css('top', headerHeight + 'px');
        if (!$categoryWrapper.hasClass("sticky"))
          $categoryWrapper.addClass("sticky").css("top", 0 + "px");
        if ($salesNav.is(":visible")) $salesNav.hide();
      } else {
        if ($categoryWrapper.hasClass("sticky")) {
          $categoryWrapper.removeClass("sticky").css("top", "");
          updateCategoryWrapperTop();
        }
        if ($salesNav.is(":hidden")) $salesNav.show();
      }

      // 建议增加一个偏移量（offset），比如 headerHeight + 10，防止刚好压线时不触发
      var threshold = headerHeight + 100;

      // 获取两个目标区块距离顶部的距离
      var hotSaleTop = $("#hot-sale-products").offset()
        ? $("#hot-sale-products").offset().top
        : 0;
      var moreProductsTop = $("#more-products").offset()
        ? $("#more-products").offset().top
        : 0;

      var $categories = $(".category-wrapper .category");

      if (scrollTop + threshold >= moreProductsTop) {
        // 滚动到 "More Products" 区域
        $categories.removeClass("active");
        $categories
          .filter('[data-category="more-products"]')
          .addClass("active");
      } else {
        // 还在 "Hot Sale" 区域
        $categories.removeClass("active");
        $categories
          .filter('[data-category="hot-sale-products"]')
          .addClass("active");
      }
    }
  }

  // 初始化
  initCategory();
  lastIsMobile = $(window).width() < 768;

  // 滚动事件
  // $(window).on("scroll", handleScroll);

  // 窗口大小变化
  $(window).on("resize", function () {
    var isMobile = $(this).width() < 768;

    if (isMobile !== lastIsMobile) {
      lastIsMobile = isMobile;
      initCategory();

      if (!isMobile) {
        $salesNav.show();
        $categoryWrapper.removeClass("sticky").css("top", "");
      } else {
        setTimeout(function () {
          updateHeaderHeight();
          updateCategoryWrapperTop();
          updateSectionBottom();
          // handleScroll();
        }, 100);
      }
    } else {
      // 即使设备类型没变，窗口大小变化时也要重新计算位置
      setTimeout(function () {
        updateHeaderHeight();
        updateCategoryWrapperTop();
        updateSectionBottom();
        // handleScroll();
      }, 100);
    }
  });
});

// nav点击切换
document.addEventListener("DOMContentLoaded", function () {
  const buttonLinks = document.querySelectorAll(
    ".event-sale-pre-swiper-product .category-wrapper .category",
  );

  buttonLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const href = "#" + this.dataset.category;

      if (href === "#") return;

      e.preventDefault();

      const target = document.querySelector(href);
      if (target) {
        // 计算目标位置，考虑导航栏偏移
        const siteHeaderHeight =
          document.querySelector(".site-header").offsetHeight;
        const categoryWrapperHeight = document.querySelector(
          ".event-sale-pre-swiper-product .category-wrapper",
        ).offsetHeight;
        const pageHeaderHeight = document.querySelector(
          ".spring-sale-pre-nav",
        ).offsetHeight;
        const targetPosition =
          target.getBoundingClientRect().top +
          window.pageYOffset -
          siteHeaderHeight -
          categoryWrapperHeight -
          pageHeaderHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    });
  });
});

function parseGiftVariants(raw) {
  if (!raw) return [];

  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    try {
      const decoded = $("<textarea />").html(raw).text();
      const parsed = JSON.parse(decoded);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e2) {
      return [];
    }
  }
}

function updateSwiperGiftByIndex($containers, vindex) {
  if (!$containers || !$containers.length) return;

  const indexNum = Number.parseInt(vindex, 10);
  const safeIndex = Number.isFinite(indexNum) ? indexNum : 0;

  $containers.each(function () {
    const $gift = $(this);

    const variants = parseGiftVariants($gift.attr("data-variants"));
    const matched = variants.find(
      (v) => Number.parseInt(v.index, 10) === safeIndex,
    );
    const fallback = variants.find((v) => Number.parseInt(v.index, 10) === 0);
    const item = matched || fallback;

    const percentText = (item && item.gift__inventory_percent) || "0%";
    const quantityText = (item && item.gift__inventory_quantity) || "0";
    $gift
      .find(".event-sale-pre-swiper-gift__inventory_quantity")
      .text(quantityText);

    const widthPercent = Math.max(
      0,
      Math.min(100, Number.parseFloat(percentText) || 0),
    );
    $gift
      .find(".event-sale-pre-swiper-gift__inventory_bar_fill")
      .css("width", widthPercent + "%");

    const $imgs = $gift.find(".event-sale-pre-swiper-gift__image_item");
    if ($imgs.length) {
      $imgs.attr("data-active", "false");
      const $byIndex = $imgs
        .filter("[data-index='" + safeIndex + "']")
        .first();
      ($byIndex.length ? $byIndex : $imgs.first()).attr(
        "data-active",
        "true",
      );
    }
  });
}

function syncGiftForVariantChange($trigger, vindex) {
  const $component = $trigger.closest("event-sale-pre-swiper-product").length
    ? $trigger.closest("event-sale-pre-swiper-product")
    : $trigger.closest(".event-sale-pre-swiper-product");
  if (!$component.length) return;

  const $slide = $trigger.closest(".swiper-slide");
  if (!$slide.length) return;

  const slideIndex = $slide.index();
  const $giftSlide = $component
    .find(".event-sale-pre-swiper_gift-container .swiper-slide")
    .eq(slideIndex);

  const $targets = $slide
    .find(".event-sale-pre-swiper-gift-container")
    .add($giftSlide);

  updateSwiperGiftByIndex($targets, vindex);
}

//switch product's variants（命名空间 + 先 off：避免同 asset 被加载多次时重复绑定）
$(".event-sale-pre-swiper-product .variant-item")
  .off("click.eventSalePreSwiperProduct")
  .on("click.eventSalePreSwiperProduct", function () {
  var vid = $(this).attr("data-id");
  var vindex = $(this).attr("data-index");
  var pid = $(this).attr("data-pid");
  $(this).addClass("active").siblings().removeClass("active");
  $(".event-sale-pre-swiper-product .variant-wrapper[data-id=" + vid + "]")
    .addClass("active")
    .siblings()
    .removeClass("active");
  $(
    ".event-sale-pre-swiper-product .variant-img[data-index=" +
    vindex +
    "][data-pid=" +
    pid +
    "]",
  )
    .addClass("active")
    .siblings()
    .removeClass("active");

  $(
    ".event-sale-pre-swiper-product .buy-card .price[data-index=" +
    vindex +
    "][data-pid=" +
    pid +
    "]",
  )
    .addClass("active")
    .siblings()
    .removeClass("active");

  syncGiftForVariantChange($(this), vindex);

  if (window.innerWidth <= 768) {
    if (vid == "46577894949089") {
      $(
        ".event-sale-pre-swiper-product .product-box .buy-card .product-benefit-img",
      ).hide();
      $(
        ".event-sale-pre-swiper-product .product-box .buy-card .product-benefit-img.mb-black",
      ).show();
    } else if (vid == "46577894981857") {
      $(
        ".event-sale-pre-swiper-product .product-box .buy-card .product-benefit-img",
      ).hide();
      $(
        ".event-sale-pre-swiper-product .product-box .buy-card .product-benefit-img.mb-white",
      ).show();
    }
  }
});
var isMobile = window.innerWidth <= 768;

function toggleImg(isMobile) {
  const $img = $(
    ".event-sale-pre-swiper-product .product-box .buy-card .product-benefit-img",
  );
  isMobile ? $img.show() : $img.hide();
}

// 初始化
toggleImg(isMobile);

window.addEventListener("resize", () => {
  const nowMobile = window.innerWidth <= 768;

  // 只有跨过 768 才执行
  if (isMobile !== nowMobile) {
    toggleImg(nowMobile);
  }

  isMobile = nowMobile;
});

// 阻止跳转加购（命名空间避免同一脚本多次执行时重复绑定；stopPropagation 避免 document 上委托的 submit 再提交一次）
$(function () {
  $(".event-sale-pre-swiper-product .add-to-cart-form2")
    .off("submit.eventSalePreSwiperProduct")
    .on("submit.eventSalePreSwiperProduct", function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      ShopifyAPI.addItemFromForm2(
        evt.target,
        ajaxCart.itemAddedCallback,
        ajaxCart.itemErrorCallback,
      );
    });
});

//openmeet 切换控制
$(".event-sale-pre-swiper-product .openmeet .toggle-product-option-item")
  .off("click.eventSalePreSwiperProduct")
  .on("click.eventSalePreSwiperProduct", function () {
    $(this).addClass("active").siblings().removeClass("active");
    var $this = $(this);
    setTimeout(function () {
      //usb-a 和 usb-c 和 no
      var now_product = $this.attr("data-product-handle");
      var now_type = $this.attr("data-option-size");

      $(
        ".event-sale-pre-swiper-product .toggle-product-option-size .toggle-product-option-item[data-product-handle='" +
        now_product +
        "']",
      )
        .addClass("active")
        .siblings()
        .removeClass("active");

      $(
        ".event-sale-pre-swiper-product ." + now_product + " .color_list li",
      ).css("display", "none");
      $(
        ".event-sale-pre-swiper-product ." +
        now_product +
        " .color_list li[data-option2='" +
        now_type +
        "']",
      ).css("display", "block");
      var v_id = $(
        ".event-sale-pre-swiper-product ." +
        now_product +
        " .color_list li[data-option2='" +
        now_type +
        "']",
      )
        .eq(0)
        .attr("data-var_id");
      $(
        ".event-sale-pre-swiper-product ." +
        now_product +
        " .color_list li[data-option2='" +
        now_type +
        "'][data-var_id='" +
        v_id +
        "']",
      ).click();
    }, 100);
  });

//opencomm2uc2025upgrade 切换控制
$(
  ".event-sale-pre-swiper-product .opencomm2uc2025upgrade .toggle-product-option-item",
)
  .off("click.eventSalePreSwiperProduct")
  .on("click.eventSalePreSwiperProduct", function () {
  $(this).addClass("active").siblings().removeClass("active");
  var $this = $(this);
  setTimeout(function () {
    //usb-a 和 usb-c
    var now_product = $this.attr("data-product-handle");
    var now_type = $this.attr("data-option-size");

    $(
      ".event-sale-pre-swiper-product .toggle-product-option-size .toggle-product-option-item[data-product-handle='" +
      now_product +
      "']",
    )
      .addClass("active")
      .siblings()
      .removeClass("active");

    $(".event-sale-pre-swiper-product ." + now_product + " .color_list li").css(
      "display",
      "none",
    );
    $(
      ".event-sale-pre-swiper-product ." +
      now_product +
      " .color_list li[data-option2='" +
      now_type +
      "']",
    ).css("display", "block");
    var v_id = $(
      ".event-sale-pre-swiper-product ." +
      now_product +
      " .color_list li[data-option2='" +
      now_type +
      "']",
    )
      .eq(0)
      .attr("data-var_id");
    $(
      ".event-sale-pre-swiper-product ." +
      now_product +
      " .color_list li[data-option2='" +
      now_type +
      "'][data-var_id='" +
      v_id +
      "']",
    ).click();
  }, 100);
});

//openrun size 切换控制
$(
  '.event-sale-pre-swiper-product .openrun .toggle-product-option-item',
)
  .off('click.eventSalePreSwiperProduct')
  .on('click.eventSalePreSwiperProduct', function () {
  $(this).addClass('active').siblings().removeClass('active');
  var $this = $(this);
  setTimeout(function () {
    //mini standard
    if ($this.hasClass('toggle-product-size-item')) {
      var now_product = $this.attr('data-product-handle');
      var now_size = $this.attr('data-option-size');
    } else {
      //usb-c 和 磁吸
      var now_product = $this.attr('data-product-handle');
      var now_size = $(
        `.event-sale-pre-swiper-product .${now_product} .toggle-product-option-size .toggle-product-option-item.active`
      ).attr('data-option-size');
    }
    $(
      ".event-sale-pre-swiper-product .toggle-product-option-size .toggle-product-option-item[data-product-handle='" +
      now_product +
      "'][data-option-size='" +
      now_size +
      "']"
    )
      .addClass('active')
      .siblings()
      .removeClass('active');

    $('.event-sale-pre-swiper-product .' + now_product + ' .color_list li').css('display', 'none');
    $(
      '.event-sale-pre-swiper-product .' + now_product + " .color_list li[data-option-size='" + now_size + "']"
    ).css('display', 'block');
    var v_id = $(
      '.event-sale-pre-swiper-product .' + now_product + " .color_list li[data-option-size='" + now_size + "']"
    )
      .eq(0)
      .attr('data-var_id');
    $(
      '.event-sale-pre-swiper-product .' +
      now_product +
      " .color_list li[data-option-size='" +
      now_size +
      "'][data-var_id='" +
      v_id +
      "']"
    ).click();
  }, 100);
});

//Openrun pro2 mini产品切换
$(
  ".event-sale-pre-swiper-product .openrun-pro2 .toggle-product-option-item",
)
  .off("click.eventSalePreSwiperProduct")
  .on("click.eventSalePreSwiperProduct", function () {
  $(this).addClass("active").siblings().removeClass("active");
  var $this = $(this);
  setTimeout(function () {
    //mini standard
    var now_product = $this.attr("data-product-handle");
    var now_size = $this.attr("data-option-size");
    $(
      ".event-sale-pre-swiper-product .toggle-product-option-size .toggle-product-option-item[data-product-handle='" +
      now_product +
      "'][data-option-size='" +
      now_size +
      "']",
    )
      .addClass("active")
      .siblings()
      .removeClass("active");

    $(".event-sale-pre-swiper-product ." + now_product + " .color_list li").css(
      "display",
      "none",
    );
    $(
      ".event-sale-pre-swiper-product ." +
      now_product +
      " .color_list li[data-option-size='" +
      now_size +
      "']",
    ).css("display", "block");
    var v_id = $(
      ".event-sale-pre-swiper-product ." +
      now_product +
      " .color_list li[data-option-size='" +
      now_size +
      "']",
    )
      .eq(0)
      .attr("data-var_id");
    $(
      ".event-sale-pre-swiper-product ." +
      now_product +
      " .color_list li[data-option-size='" +
      now_size +
      "'][data-var_id='" +
      v_id +
      "']",
    ).click();
  }, 100);
});

// {% comment %} 曝光埋点 {% endcomment %}
function getEventSalePreSwiperProductBuyCardDataString(buyCardRoot) {
  const $buyCard =
    buyCardRoot && buyCardRoot.nodeType === 1
      ? $(buyCardRoot)
      : $(buyCardRoot);
  let $div = $buyCard.find(".variant-wrapper.active .product-data-div");
  if (!$div.length) {
    $div = $buyCard.find(".product-data-div").first();
  }
  return $div.attr("data-product-data") || "";
}

var record_export_collection = new Set();
var time_interval_home_product_list = -1;
var home_product_list_attr = [];
function home_product_ga4_deal_list(collection) {
  clearInterval(time_interval_home_product_list);
  let groupedItems = {}; // 用于存储按 item_list_id 分组的商品数组
  let collection_item = "";
  collection.forEach((element, index) => {
    const raw =
      typeof element === "string"
        ? element
        : getEventSalePreSwiperProductBuyCardDataString(element);
    if (!raw) return;
    collection_item = raw.split("::");
    let $v_item_name = "";
    let $v_item_variant = "";
    let $v_item_category = "";
    let $v_item_category2 = "Standard";
    if (product_handle_map.has(collection_item[0])) {
      $v_item_name = product_handle_valueMap[collection_item[0]][0];
      $v_item_variant = product_handle_valueMap[collection_item[0]][1];
      $v_item_category = product_handle_valueMap[collection_item[0]][2];
      $v_item_category2 = product_handle_valueMap[collection_item[0]][3];
    }

    let arr_item = {
      item_id: collection_item[0],
      item_name: $v_item_name,
      index: collection_item[2],
      item_list_id: collection_item[4],
      item_list_name: collection_item[4],
      item_category: $v_item_category,
      item_category2: $v_item_category2,
      item_category3: collection_item[6].replace("Default Title", "none"),
      item_variant: $v_item_variant,
      item_brand: "SHOKZ",
      price: Number(
        collection_item[9].split("$").join("").split(",").join("."),
      ),
      quantity: Number(collection_item[10]),
      currency: "AUD",
    };
    // 根据 item_list_name 分组商品
    if (!groupedItems[collection_item[4].split(" ").join("")]) {
      groupedItems[collection_item[4].split(" ").join("")] = []; // 如果没有该组，初始化为空数组
    }
    groupedItems[collection_item[4].split(" ").join("")].push(arr_item); // 将当前商品添加到对应的组中
  });
  // console.log(final_arr);

  // 遍历分组并触发 dataLayer.push
  for (const itemListId in groupedItems) {
    if (groupedItems.hasOwnProperty(itemListId)) {
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: "ga4Event",
        event_name: "view_item_list",
        event_parameters: {
          currency: "AUD",
          item_list_id: groupedItems[itemListId][0]["item_list_name"],
          item_list_name: groupedItems[itemListId][0]["item_list_name"],
          items: groupedItems[itemListId], // 推送当前 item_list_name 对应的商品数组
        },
      });
    }
  }
}

// 创建一个 Intersection Observer 实例（整页只注册一次，避免 asset 重复执行时重复 observe）
if (!window.__eventSalePreSwiperProductBuyCardIO) {
  window.__eventSalePreSwiperProductBuyCardIO = true;
  var observer_home_product = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // 在这里可以添加埋点逻辑
        let product_item = getEventSalePreSwiperProductBuyCardDataString(
          entry.target,
        );
        if (!product_item) {
          observer_home_product.unobserve(entry.target);
          return;
        }
        // console.log('元素曝光:', product_item);

        product_item = product_item.split("::");
        let product_item_record = product_item[3] + product_item[8];
        product_item_record = product_item_record.split(" ").join("-");

        if (!record_export_collection.has(product_item_record)) {
          record_export_collection.add(product_item_record);
          // home_product_ga4_deal(product_item,"","view_item_list")
          home_product_list_attr.push(entry.target);
          clearInterval(time_interval_home_product_list);
          time_interval_home_product_list = setInterval(function () {
            clearInterval(time_interval_home_product_list);
            home_product_ga4_deal_list(home_product_list_attr);
            home_product_list_attr = [];
          }, 3000);
        }
        // 例如，发送曝光事件到服务器
        observer_home_product.unobserve(entry.target); // 可选：如果只需要一次曝光，可以取消观察
      }
    });
  });

  // 选择要观察的元素
  var targetElements_home_product = document.querySelectorAll(
    ".event-sale-pre-swiper-product .buy-card",
  );
  targetElements_home_product.forEach((element) => {
    observer_home_product.observe(element); // 开始观察每个元素
  });
}

// {% comment %} 产品加购埋点 {% endcomment %}
function page_product_ga4_deal(
  product_item,
  buttom_name,
  event_name,
  discount = 0,
) {
  let $v_item_name = "";
  let $v_item_variant = "";
  let $v_item_category = "";
  let $v_item_category2 = "Standard";
  if (product_handle_map.has(product_item[0])) {
    $v_item_name = product_handle_valueMap[product_item[0]][0];
    $v_item_variant = product_handle_valueMap[product_item[0]][1];
    $v_item_category = product_handle_valueMap[product_item[0]][2];
    $v_item_category2 = product_handle_valueMap[product_item[0]][3];
  }

  window.dataLayer.push({ event_parameters: null });
  window.dataLayer.push({
    event: "ga4Event",
    event_name: event_name,
    event_parameters: {
      item_list_id: product_item[4],
      item_list_name: product_item[4],
      currency: "AUD",
      button_name: buttom_name,
      items: [
        {
          item_id: product_item[0],
          item_name: $v_item_name,
          index: 1,
          item_list_id: product_item[4],
          item_list_name: product_item[4],
          item_category: $v_item_category,
          item_category2: $v_item_category2,
          item_category3: product_item[6].replace("Default Title", "none"),
          item_variant: $v_item_variant,
          item_brand: "SHOKZ",
          price: Number(
            product_item[9].split("$").join("").split(",").join("."),
          ),
          quantity: Number(product_item[10]),
          currency: "AUD",
          discount: discount,
        },
      ],
    },
  });
}

function getDiscount($trigger) {
  const $buyCard = $trigger.closest(".buy-card");
  // 当前价格（不包含对比价）
  const priceText = $buyCard
    .find(".price.active")
    .clone()
    .children()
    .remove()
    .end()
    .text()
    .replace(/[^\d.]/g, "");

  // 对比价
  const compareText = $buyCard
    .find(".price.active .tag_sale-compare-price")
    .text()
    .replace(/[^\d.]/g, "");

  const price = parseFloat(priceText) || 0;
  const compare_at_price = parseFloat(compareText) || 0;

  const discount =
    compare_at_price > price ? +(compare_at_price - price).toFixed(2) : 0;
  return discount;
}

$(
  ".event-sale-pre-swiper-product .buy-card .variant-buttons .addtocart",
)
  .off("click.eventSalePreSwiperProduct")
  .on("click.eventSalePreSwiperProduct", function () {
    let product_item = $(this).attr("data-product-data");
    product_item = product_item.split("::");
    page_product_ga4_deal(
      product_item,
      $(this).text().trim(),
      "add_to_cart",
      getDiscount($(this)),
    );
  });

$(".event-sale-pre-swiper-product .buy-card .product-link")
  .off("click.eventSalePreSwiperProduct")
  .on("click.eventSalePreSwiperProduct", function () {
    let product_item = getEventSalePreSwiperProductBuyCardDataString(
      $(this).closest(".buy-card"),
    );
    if (!product_item) return;
    product_item = product_item.split("::");
    page_product_ga4_deal(
      product_item,
      "Product link",
      "select_item",
      getDiscount($(this)),
    );
  });

$(".event-sale-pre-swiper-product .buy-card .product-title")
  .off("click.eventSalePreSwiperProduct")
  .on("click.eventSalePreSwiperProduct", function () {
    let product_item = getEventSalePreSwiperProductBuyCardDataString(
      $(this).closest(".buy-card"),
    );
    if (!product_item) return;
    product_item = product_item.split("::");
    page_product_ga4_deal(
      product_item,
      "Product title",
      "select_item",
      getDiscount($(this)),
    );
  });

$(".event-sale-pre-swiper-product .buy-card .variants-img-wrapper")
  .off("click.eventSalePreSwiperProduct")
  .on("click.eventSalePreSwiperProduct", function () {
    let product_item = $(this)
      .find(".product-img.active")
      .attr("data-product-data");
    product_item = product_item.split("::");
    page_product_ga4_deal(
      product_item,
      "Product Image link",
      "select_item",
      getDiscount($(this)),
    );
  });

$(".event-sale-pre-swiper-product .product-box .poster-link")
  .off("click.eventSalePreSwiperProduct")
  .on("click.eventSalePreSwiperProduct", function () {
    const $card = $(this).closest(".product-box");
    let product_item = $card
      .find(".buy-card .variants-img-wrapper .product-img.active")
      .attr("data-product-data");
    product_item = product_item.split("::");
    page_product_ga4_deal(
      product_item,
      "Product Poster link",
      "select_item",
      getDiscount($(this)),
    );
  });


// 自定义优先展示变体
$('.event-sale-pre-swiper-product .product-box').each(function () {
  const $this = $(this);
  const variantIndex = $this.data('variant-index');
  if (variantIndex) {
    $this.find('.variant-item').eq(variantIndex - 1).trigger('click');
  }
});